export const CLOSE_THRESHOLD_PX = 10;
export const AXIS_LOCK_ANGLES_DEG = [0, 45, 90, 135, 180, 225, 270, 315] as const;
export const VERTEX_HANDLE_RADIUS_PX = 4;
export const VERTEX_HANDLE_HOVER_RADIUS_PX = 7;
export const MIN_VERTEX_COUNT = 3;
